import { observable, action } from 'mobx';
import { Fssp } from 'api';

class FsspStore {
  @observable.ref items = [];

  @observable fetchState;

  anketId;

  @action.bound
  async getExecutiveProceedings(anketId) {
    if (this.anketId === anketId) {
      return;
    }

    this.fetchState = 'pending';

    try {
      const response = await Fssp.getExecutiveProceedings(anketId);
      this.items = response.data;
      this.fetchState = 'fulfilled';
      this.anketId = anketId;
    } catch (e) {
      this.fetchState = 'rejected';
    }
  }
}

const fsspStore = new FsspStore();

export default fsspStore;
